import { useState, useEffect } from 'react';
import { useExternalTokenAuth, useGetOrganization } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';

export const useExternalToken = () => {
  const organizationId = useUserSetupStore(state => state.organization.id);
  const { data: organizationData } = useGetOrganization(organizationId);
  const [agentToken, setAgentToken] = useState<string>();

  const { mutate: getAgentToken } = useExternalTokenAuth(
    organizationId,
    organizationData?.aiPort,
    {
      onSuccess: data => {
        const token = data?.access_token;
        if (token && typeof token === 'string') {
          setAgentToken(token);
        }
      },
    }
  );

  useEffect(() => {
    if (organizationId && organizationData?.aiEnabled) {
      setAgentToken(undefined);
      getAgentToken({ orgId: organizationId });
    }
  }, [organizationId, organizationData?.aiEnabled, getAgentToken]);

  return {
    agentToken,
    isAiEnabled: organizationData?.aiEnabled ?? false,
    organizationData,
  };
};
